import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { dataProvider } from '@src/dataProvider';

const colors = ['#5856d6', '#39f', '#f9b115', '#e55353', '#5856d6', '#39f', '#f9b115', '#e55353'];

const StyledCard = styled(Card)(({ color }) => ({
    backgroundColor: color,
    color: '#fff',
}));

type CardData = {
    label: string;
    count: number;
};

export const Dashboard = () => {
    const [cards, setCards] = useState<CardData[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await dataProvider.getDashboardCards('dashboard/cards');
                setCards(data);
            } catch (err) {
                console.error('Fetch error:', err);
            }
        };

        fetchData();
    }, []);

    return (
        <Grid container spacing={2} style={{ marginTop: '5px' }}>
            {cards.map((card, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <StyledCard color={colors[index % colors.length]}>
                        <CardHeader title={card.label} />
                        <CardContent>
                            <Typography variant="h4">{card.count.toLocaleString()}</Typography>
                        </CardContent>
                    </StyledCard>
                </Grid>
            ))}
        </Grid>
    );
};